export interface Project {
  id: string;
  title: string;
  category: "Construction" | "Travaux Publics" | "Logistique";
  location: string;
  description: string;
  imageLabel: string;
  imageSrc: string;
}

export const projects: Project[] = [
  {
    id: "r4-gambela",
    title: "Bâtiment R+4, Gambela",
    category: "Construction",
    location: "Commune de Lubumbashi, Quartier Gambela",
    description: "Construction d'un immeuble résidentiel et commercial de 4 étages. Structure en béton armé, finitions de qualité supérieure.",
    imageLabel: "Bâtiment R+4 en construction",
    imageSrc: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&q=80&auto=format&fit=crop",
  },
  {
    id: "route-gaston-denis",
    title: "Route agricole, Village Gaston-Denis",
    category: "Travaux Publics",
    location: "Village Gaston-Denis, Haut-Katanga",
    description: "Aménagement et construction d'une route agricole reliant le village aux axes principaux. Terrassement, compactage et mise en forme.",
    imageLabel: "Route en construction",
    imageSrc: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800&q=80&auto=format&fit=crop",
  },
  {
    id: "forage-nsele",
    title: "Forage de puits, École N'Sele",
    category: "Travaux Publics",
    location: "Commune de N'Sele, Kinshasa",
    description: "Forage d'un puits d'eau potable pour une école privée. Accès à l'eau propre pour des centaines d'élèves.",
    imageLabel: "Forage de puits",
    imageSrc: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800&q=80&auto=format&fit=crop",
  },
  {
    id: "toiture-gecamines",
    title: "Toiture métallique, GECAMINE STL",
    category: "Construction",
    location: "GECAMINE STL, Haut-Katanga",
    description: "Réalisation d'une toiture métallique de grande envergure. Charpente métallique, couverture et étanchéité.",
    imageLabel: "Structure métallique industrielle",
    imageSrc: "https://images.unsplash.com/photo-1587582423116-ec07293f0395?w=800&q=80&auto=format&fit=crop",
  },
  {
    id: "guest-house-rva",
    title: "Guest House, Avenue Mufwankolo",
    category: "Construction",
    location: "Quartier RVASAR, Lubumbashi",
    description: "Construction d'une guest house moderne. Architecture contemporaine avec aménagements extérieurs.",
    imageLabel: "Guest house en construction",
    imageSrc: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800&q=80&auto=format&fit=crop",
  },
  {
    id: "appro-mbuji-mayi",
    title: "Approvisionnement SNCC, Mbuji-Mayi",
    category: "Logistique",
    location: "Afrique du Sud via SNCC",
    description: "Approvisionnement en matériaux et équipements depuis l'Afrique du Sud via le réseau ferroviaire SNCC.",
    imageLabel: "Transport de matériaux",
    imageSrc: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800&q=80&auto=format&fit=crop",
  },
];

export const projectFilters = ["Tous", "Construction", "Travaux Publics", "Logistique"] as const;
